import { AuditStatusesTable } from "@/components/settings/AuditStatusesTable";
import { RecipientTeamsSection } from "@/components/settings/RecipientTeamsSection";
import { StaleAuditSection } from "@/components/settings/StaleAuditSection";
import { PageHeader } from "@/components/shared/page-header";

export function SettingsSystemPage() {
  return (
    <div className="space-y-10">
      <section className="space-y-4">
        <PageHeader title="Audit Statuses" />
        <AuditStatusesTable />
      </section>
      <section className="space-y-4">
        <PageHeader title="Recipient Teams" />
        <RecipientTeamsSection />
      </section>
      <section className="space-y-4">
        <PageHeader title="Audit Attention" />
        <StaleAuditSection />
      </section>
    </div>
  );
}
